var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgK3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.026,
    height: 39.676,
    viewBox: "735 2165 39.026 39.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "bullhorn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.765 2199.473h-1.3v-6.374a.65.65 0 1 0-1.302 0v6.374h-16.91v-13.009h5.41a.65.65 0 1 0 0-1.3h-6.061a.65.65 0 0 0-.65.65v13.659h-1.302a.65.65 0 0 0-.65.65v1.301a3.252 3.252 0 0 0 3.252 3.252h16.911a3.252 3.252 0 0 0 3.253-3.252v-1.3a.65.65 0 0 0-.65-.651Zm-.65 1.951a1.951 1.951 0 0 1-1.952 1.951h-1.3v-.65a.65.65 0 0 0-1.301 0v.65h-11.708v-.65a.65.65 0 0 0-1.301 0v.65h-1.3a1.951 1.951 0 0 1-1.952-1.95v-.651h20.814v.65Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.822 2169.553h1.301a.65.65 0 1 0 0-1.3h-1.3a1.951 1.951 0 0 0-1.952 1.95v.65h-.65a.65.65 0 1 0 0 1.302h.65v1.951a.65.65 0 1 0 1.301 0v-1.951h.65a.65.65 0 0 0 0-1.301h-.65v-.65c0-.36.291-.651.65-.651Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.075 2165.65h-7.806a1.951 1.951 0 0 0-1.95 1.952v1.3a.65.65 0 0 0 1.3 0v-1.3c0-.36.291-.65.65-.65h7.806c.359 0 .65.29.65.65v7.805a.65.65 0 0 1-.65.65h-7.806a.65.65 0 0 1-.65-.65v-3.903a.65.65 0 0 0-1.3 0v3.903c0 1.078.873 1.951 1.95 1.951h7.806a1.951 1.951 0 0 0 1.95-1.951v-7.805a1.951 1.951 0 0 0-1.95-1.952Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.57 2191.668a2.602 2.602 0 1 0 5.204 0 2.602 2.602 0 0 0-5.204 0Zm3.903 0a1.3 1.3 0 1 1-2.602 0 1.3 1.3 0 0 1 2.602 0Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.075 2185.814h-7.806a1.951 1.951 0 0 0-1.95 1.951v7.805c0 1.078.873 1.952 1.95 1.952h7.806a1.951 1.951 0 0 0 1.95-1.952v-1.3a.65.65 0 0 0-1.3 0v1.3a.65.65 0 0 1-.65.65h-7.806a.65.65 0 0 1-.65-.65v-7.805c0-.36.291-.65.65-.65h7.806c.359 0 .65.29.65.65v3.903a.65.65 0 1 0 1.3 0v-3.903a1.951 1.951 0 0 0-1.95-1.951Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.615 2173.358a.65.65 0 0 0 .638.026l3.902-1.951a.65.65 0 0 0 0-1.158l-3.902-1.951a.65.65 0 0 0-.944.579v3.902a.65.65 0 0 0 .306.553Zm.995-3.402 1.796.898-1.796.897v-1.795Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.26 2176.708a5.854 5.854 0 1 0 0-11.708 5.854 5.854 0 0 0 0 11.708Zm0-10.407a4.553 4.553 0 1 1 0 9.106 4.553 4.553 0 0 1 0-9.106Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.765 2179.31a.65.65 0 0 0 .52-.26l1.952-2.602a.65.65 0 1 0-1.041-.78l-1.951 2.6a.65.65 0 0 0 .52 1.041Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.196 2181.651a.65.65 0 0 0 .91.13l2.602-1.951a.65.65 0 0 0-.78-1.04l-2.602 1.95a.65.65 0 0 0-.13.911Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.57 2183.082a.65.65 0 0 0-.78-.52l-3.252.65a.654.654 0 0 0 .13 1.3h.13l3.252-.65a.65.65 0 0 0 .52-.78Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.65 2183.212h7.806a.65.65 0 0 0 .65-.65v-10.407a.65.65 0 0 0-.65-.65h-7.806a.65.65 0 0 0-.65.65v10.407c0 .359.291.65.65.65Zm.65-10.407h6.505v9.106h-6.504v-9.106Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.854 2174.106h-1.301a.65.65 0 0 0 0 1.3h1.3a.65.65 0 1 0 0-1.3Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.854 2176.708h-2.602a.65.65 0 0 0 0 1.3h2.602a.65.65 0 1 0 0-1.3Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.854 2179.31h-2.602a.65.65 0 1 0 0 1.3h2.602a.65.65 0 0 0 0-1.3Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.193 2183.017a.653.653 0 1 0-1.132.65l2.868 4.963-10.407 3.903h-.097l-1.691.975-1.125.65a1.3 1.3 0 0 1-1.776-.474l-1.301-2.25a1.3 1.3 0 0 1 .488-1.718l2.25-1.3 1.626 2.816a.65.65 0 0 0 .566.325.65.65 0 0 0 .566-.976l-1.678-2.9 8.163-6.732.267.461a.653.653 0 0 0 1.131-.65l-.65-1.125a.65.65 0 0 0-.449-.313.65.65 0 0 0-.533.137l-9.106 7.506-2.771 1.6a2.602 2.602 0 0 0-1.197 2.947l-.65.37a1.951 1.951 0 1 0 1.951 3.383l.65-.371a2.524 2.524 0 0 0 1.822.767c.457.001.906-.12 1.3-.35l.566-.326 1.301 2.257a1.951 1.951 0 0 0 3.571-.47c.134-.5.064-1.033-.195-1.481l-1.184-2.062 9.757-3.662a.65.65 0 0 0 .338-.93l-3.24-5.62Zm-15.363 11.116a.65.65 0 0 1-.495.065.65.65 0 0 1-.397-.3.65.65 0 0 1 .241-.89l.566-.326.65 1.126-.565.325Zm8.56 1.821a.65.65 0 0 1 .064.494.65.65 0 0 1-.305.39.65.65 0 0 1-.885-.234l-1.3-2.257 1.079-.617h.052l1.294 2.224Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Path 2369"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgK3);
export default __webpack_public_path__ + "static/media/k3.f3c1f013b6b4205580aab18584159e2a.svg";
export { ForwardRef as ReactComponent };